import React, {Component} from 'react'
import PropTypes from 'prop-types'

import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Tabs, Tab, withStyles} from '@material-ui/core'
import {Redirect} from 'react-router-dom'
import {PageContainer} from '../../components/components'
import {BasicInfo, MediaUpdate, DownloadsEdit, FeaturesEdit, ReadmeEdit} from './Tabs/Tabs'
import {metaActions, projectActions} from '../../core/actions'
import {titlePrefix} from '../../index'


const styles = {
    container: {
        paddingTop: '5em'
    },

    pageContainer: {
        paddingTop: '1em'
    }
}

const mapStateToProps = state => ({
    isFetchingMetas: state.meta.isFetchingMetas,
    isLoadingDetails: state.project.isLoadingDetails,
    isUpdatingProject: state.project.isUpdatingProject,
    projectDetails: state.project.projectDetails,
    user: state.auth.user,
    metas: state.meta.metas
})

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({...projectActions, ...metaActions}, dispatch)
})

const buildTab = (title, hashName) => ({
    title,
    hashName
})

const TabInfos = [
    {...buildTab('Basic Info', 'basic')},
    {...buildTab('Media', 'media')},
    {...buildTab('Downloads', 'downloads')},
    {...buildTab('Features', 'features')},
    {...buildTab('Help/Readme', 'help')}
]
const tabs = (function () {
    const result = {}
    TabInfos.forEach((tabInfo, tabIndex) => {
        result[`#${tabInfo.hashName}`] = tabIndex
    })
    return result
}())

const getDefaultTab = function (hash) {
    return tabs[hash] ? tabs[hash] : 0
}

class Edit extends Component {
    state = {
        tabIndex: getDefaultTab(this.props.location.hash)
    }

    handleChange = (event, tabIndex) => {
        this.setState({ tabIndex });
    }

    componentDidMount () {
        document.title = `${titlePrefix}Getting Info..`
        const {match} = this.props
        this.id = match.params.id
        this.props.getProjectDetails(this.id)
        this.props.getMetas()
    }

    onTabClick = tabIndex => () => {
        this.props.history.push(Object.keys(tabs)[tabIndex])
    }

    render() {
        const {classes: styles, metas, isLoadingDetails, isUpdatingProject, projectDetails, editProjectDetails, user} = this.props
        if (!user) return <Redirect to={'/'} />
        const {tabIndex} = this.state
        const tabProps = {
            metas,
            isUpdatingProject,
            projectDetails,
            editProjectDetails
        }
        if (projectDetails) document.title = `${titlePrefix}Editor for ${projectDetails.name}`
        return (
            <div className={styles.container}>
                <Tabs
                    value={this.state.tabIndex}
                    onChange={this.handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    {TabInfos.map((tabInfo, index) => <Tab key={index} label={tabInfo.title} onClick={this.onTabClick(index)} />)}
                </Tabs>
                <PageContainer gridProps={{xl: 6, lg: 6}} isLoadingContent={isLoadingDetails} loaderText={'Getting Info'} containerClassName={styles.pageContainer}>

                    <BasicInfo {...tabProps} active={tabIndex === 0} />

                    <MediaUpdate {...tabProps} active={tabIndex === 1} />

                    <DownloadsEdit {...tabProps} active={tabIndex === 2} />

                    <FeaturesEdit {...tabProps} active={tabIndex === 3} />

                    <ReadmeEdit {...tabProps} active={tabIndex === 4} />
                </PageContainer>
            </div>
        )
    }
}

Edit.propTypes = {
    classes: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Edit))
